class AdminService {
    constructor(_, $http, initConfigProvider) {
        this._ = _;
        this.http = $http;
        this.apiPath = initConfigProvider.apiBaseUrl + initConfigProvider.adminServiceEndPoint;
        this.apiBasePath = initConfigProvider.apiBaseUrl;
    }

    getManageDisclosures(filter) {
        return this.http.get(`${this.apiPath}/managedisclosures?pageSize=${filter.pageSize || 50}&pageIndex=${filter.pageIndex || 1}
            &displayId=${filter.displayId || ""}&keyword=${filter.keyword || ""}&statusList=${filter.statusList || ""}&disclosureType=${filter.disclosureType || ""}
            &faculty=${filter.faculty || ""}&school=${filter.school || ""}&download=false`).then((response) => {
                if (response.status === 200) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.data && response.data.error) {
                        return {
                            data: null,
                            error: response.data.error
                        };
                    }
                }
                return {
                    data: null,
                    error: 'Manage disclosures service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'Manage disclosures service error'
                };
            });
    }

    getSchoolsByFaculty(facultyName) {
        return this.http.get(`${this.apiBasePath}/api/faculty/${facultyName}/schools`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.data && response.data.error) {
                        return {
                            data: null,
                            error: response.data.error
                        };
                    }
                }
                return {
                    data: null,
                    error: 'Manage disclosures service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'Manage disclosures service error'
                };
            });
    }

    getSchools() {
        return this.http.get(`${this.apiBasePath}/api/schools`)
            .then((response) => {
                if (response.status === 200) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else {
                    if (response.data && response.data.error) {
                        return {
                            data: null,
                            error: response.data.error
                        };
                    }
                }
                return {
                    data: null,
                    error: 'Manage disclosures service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'Manage disclosures service error'
                };
            });
    }
}

AdminService.$inject = ['_', '$http', 'initConfigProvider'];

export default AdminService;


// WEBPACK FOOTER //
// ./app/services/admin.service.js